import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=19bd3207&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=19bd3207&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd3207",
  null
  
)

export default component.exports